import { render, staticRenderFns } from "./LectorCodigos.vue?vue&type=template&id=69b0d924&scoped=true&"
import script from "./LectorCodigos.vue?vue&type=script&lang=ts&"
export * from "./LectorCodigos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b0d924",
  null
  
)

export default component.exports